<template>
  <div class="login wrapper fadeInDown">
    <div id="formContent">
      <!-- Icon -->
      <div class="fadeIn first">
        <img
          :src="
            setting_image && setting_image.logo_sgv && setting_image.logo_sgv.value ?
            setting_image.logo_sgv.value : '/img/brand/top-logo.png'
          "
          style="width: 50%; margin-top: 2vh;"
          id="icon"
          alt="User Icon"
        />
        <br />
        <br />
        <span class="h3">SISTEMA DE GERENCIAMENTO DE</span>
        <br />
        <span class="h3">VENDAS</span>
      </div>

      <form class="form-signin" @submit.prevent="sendEmail">
          <div class="form-group">
            <PasswordInput
              label=""
              placeholder="Nova Senha"
              :max="150"
              v-model="password"
              @input="checkPassword"
            />
            <div v-if="showPasswordLengthError" class="text-danger">A senha deve conter pelo menos 8 caracteres.</div>
            <div v-if="showSpecialCharError" class="text-danger">A senha deve conter pelo menos um caractere especial.</div>
            <div v-if="showUppercaseError" class="text-danger">A senha deve conter pelo menos uma letra maiúscula.</div>
            <div v-if="showLowercaseError" class="text-danger">A senha deve conter pelo menos uma letra minúscula.</div>
            <div v-if="showNumberError" class="text-danger">A senha deve conter pelo menos um número.</div>          </div>
          <div class="form-group">
            <PasswordInput
              label=""
              placeholder="Confirmação da Senha"
              :max="150"
              v-model="password_confirmation"
              @input="checkConfirmationPassword"
            />
            <div v-if="showConfirmationPasswordError" class="text-danger">As senhas não conferem!</div>
            <div
              v-if="error"
                class="invalid-feedback"
                style="display: block;"
            >
            </div>
          </div>
        <button class="btn btn-info mb-3 fadeIn fourth">
          Alterar senha
        </button>
        <div id="formFooter">
          <a class="underlineHover" href="/login">Login</a>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import PasswordInput from "../../components/Inputs/PasswordInput.vue";

export default {
  name: "Login",
  components: {
    PasswordInput,
  },
  data() {
    return {
      email: "",
      password: "",
      password_confirmation: "",
      passwordResetSuccessful: false,
      showPasswordLengthError: false,
      showSpecialCharError: false,
      showUppercaseError: false,
      showLowercaseError: false,
      showNumberError: false,
      showConfirmationPasswordError: false
    }
  },
  methods: {
    checkPassword() {
      this.showPasswordLengthError = this.password.length < 8;
      this.showSpecialCharError = !/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(this.password);
      this.showUppercaseError = !/[A-Z]/.test(this.password);
      this.showLowercaseError = !/[a-z]/.test(this.password);
      this.showNumberError = !/\d/.test(this.password);
    },
    checkConfirmationPassword() {
      this.showConfirmationPasswordError = this.password !== this.password_confirmation
    },
    sendEmail() {
      this.checkPassword()
      this.checkConfirmationPassword()

      if(!this.isPasswordValid) return;

      this.token = window.location.pathname.split('/')[2]
      this.$http.plain
        .put(`/api/v1/reset_password`, {
          user: {
            password: this.password,
            password_confirmation: this.password_confirmation,
            reset_password_token: this.token
          }
        })
        .then(response => { 
          this.$toasted.global.defaultSuccess({msg: 'Senha modificada com sucesso!'});
          this.$router.push('/login')
        })
        .catch(error => {
          if (error.response && error.response.status === 403) {
            this.$toasted.global.defaultError({ msg: "Token já utilizado. Favor solicite uma nova recuperação de senha." });
          } else if (error.response && error.response.status === 422) {
            this.$toasted.global.defaultError({ msg: "Senha já utilizada nos últimos 90 dias" });
          }
        });
      }
  },
  computed: {
    isPasswordValid() {
      return (
        !this.showPasswordLengthError &&
        !this.showSpecialCharError &&
        !this.showUppercaseError &&
        !this.showLowercaseError &&
        !this.showNumberError &&
        !this.showConfirmationPasswordError
      );
    },
    setting_image() {
      return this.$store.state.imageSettings || {}
    }
  },
}

</script>

<style lang="css">
.login .form-signin {
  width: 70%;
  max-width: 500px;
  padding: 10% 15px;
  margin: 0 auto;
}

/* BASIC */

html {
  background-color: rgb(23, 43, 77);
}

body .login {
  font-family: "Poppins", sans-serif;
  height: 100vh;
}

.login a {
  color: #92badd;
  display: inline-block;
  text-decoration: none;
  font-weight: 400;
}

.login h2 {
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  text-transform: uppercase;
  display: inline-block;
  margin: 40px 8px 10px 8px;
}

/* STRUCTURE */

.login.wrapper {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  min-height: 100%;
  padding: 20px;
}

.login #formContent {
  -webkit-border-radius: 10px 10px 10px 10px;
  border-radius: 10px 10px 10px 10px;
  background: #fff;
  padding: 30px;
  width: 90%;
  max-width: 450px;
  position: relative;
  padding: 0px;
  margin-top: 100px;
  box-shadow: 0 20px 20px 0 rgba(0, 0, 0, 0.3);
  text-align: center;
}

/* ANIMATIONS */

/* Simple CSS3 Fade-in-down Animation */
.fadeInDown {
  -webkit-animation-name: fadeInDown;
  animation-name: fadeInDown;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

@-webkit-keyframes fadeInDown {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}

@keyframes fadeInDown {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}

/* Simple CSS3 Fade-in Animation */
@-webkit-keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@-moz-keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.fadeIn {
  opacity: 0;
  -webkit-animation: fadeIn ease-in 1;
  -moz-animation: fadeIn ease-in 1;
  animation: fadeIn ease-in 1;

  -webkit-animation-fill-mode: forwards;
  -moz-animation-fill-mode: forwards;
  animation-fill-mode: forwards;

  -webkit-animation-duration: 1s;
  -moz-animation-duration: 1s;
  animation-duration: 1s;
}

.fadeIn.first {
  -webkit-animation-delay: 0.4s;
  -moz-animation-delay: 0.4s;
  animation-delay: 0.4s;
}

.fadeIn.second {
  -webkit-animation-delay: 0.6s;
  -moz-animation-delay: 0.6s;
  animation-delay: 0.6s;
}

.fadeIn.third {
  -webkit-animation-delay: 0.8s;
  -moz-animation-delay: 0.8s;
  animation-delay: 0.8s;
}

.fadeIn.fourth {
  -webkit-animation-delay: 1s;
  -moz-animation-delay: 1s;
  animation-delay: 1s;
}

/* Simple CSS3 Fade-in Animation */
.underlineHover:after {
  display: block;
  left: 0;
  bottom: -10px;
  width: 0;
  height: 2px;
  background-color: #56baed;
  content: "";
  transition: width 0.2s;
}

.underlineHover:hover {
  color: #0d0d0d;
}

.underlineHover:hover:after {
  width: 100%;
}

h1 {
  color: #60a0ff;
}
</style>